import * as singleSpa from "single-spa";
import { ROUTES } from "@creditas/home-mf-shared";
import i18n from "./i18n";
import { getOriginalPath, activeWhenHelper } from "./utils";

export function registerApplications() {
  singleSpa.registerApplication({
    name: "@creditas/home-mf-simulation",
    app: () => System.import("@creditas/home-mf-simulation"),
    activeWhen: (location) =>
      activeWhenHelper(() =>
        getOriginalPath(location.pathname).startsWith(ROUTES.SIMULATION)
      ),
    customProps: {
      i18n,
    },
  });

  singleSpa.registerApplication({
    name: "@creditas/home-mf-resume",
    app: () => System.import("@creditas/home-mf-resume"),
    activeWhen: (location) =>
      activeWhenHelper(() => {
        const originalPath = getOriginalPath(location.pathname);
        return (
          [ROUTES.PRE_QUALIFICATION, ROUTES.CROSS_SELL].includes(
            originalPath
          ) || originalPath.startsWith(ROUTES.RESUME)
        );
      }),
    customProps: {
      i18n,
    },
  });

  singleSpa.registerApplication({
    name: "@creditas/home-mf-bacen",
    app: () => System.import("@creditas/home-mf-bacen"),
    activeWhen: (location) =>
      getOriginalPath(location.pathname).startsWith(ROUTES.BACEN),
    customProps: {
      i18n,
    },
  });

  singleSpa.registerApplication({
    name: "@creditas/home-mf-profiling",
    app: () => System.import("@creditas/home-mf-profiling"),
    activeWhen: (location) =>
      activeWhenHelper(() =>
        getOriginalPath(location.pathname).startsWith(ROUTES.PROFILING)
      ),
    customProps: {
      i18n,
    },
  });

  singleSpa.registerApplication({
    name: "@creditas/home-mf-documents",
    app: () => System.import("@creditas/home-mf-documents"),
    activeWhen: (location) =>
      activeWhenHelper(() =>
        getOriginalPath(location.pathname).startsWith(ROUTES.DOCUMENTS)
      ),
    customProps: {
      i18n,
    },
  });
}
